import {
  FeatureFlagsContext,
  SiteUrlsContext,
  WarningStatusChip,
  WarningStatusProps
} from '@tableau/data-catalog-shared';
import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';
import { Query } from 'react-apollo';

import {
  DatabaseLineageUpstreamDataQualityWarningsQuery,
  DatabaseLineageUpstreamDataQualityWarningsQueryVariables,
} from '../../../gen-src/queries/DatabaseLineageUpstreamDataQualityWarningsQuery';

import { DatabaseLineageUpstreamDataQualityWarningsQueryGql } from '../../queries/DatabaseLineageUpstreamDataQualityWarningsQueryGql';
import { renderQueryResult } from '../renderQueryResult';
import { emptyWarnings, filterOutWarningsFromAnchorUntilCycleIsFixed } from './DataQualityWarningCycleTemporaryFix';

interface LineageWarningDatabaseProps {
  readonly nodeId: string;
}

export function QueryDatabaseOwnDataQualityWarnings(props: LineageWarningDatabaseProps): JSX.Element {
  const { publishedConnectionsLineageEnabled } = React.useContext(FeatureFlagsContext);
  const urls = React.useContext(SiteUrlsContext);
  const renderers = { renderData: React.useMemo(() => renderWarnings(urls), [urls]) }

  return (
    <Query<DatabaseLineageUpstreamDataQualityWarningsQuery, DatabaseLineageUpstreamDataQualityWarningsQueryVariables>
      query={DatabaseLineageUpstreamDataQualityWarningsQueryGql}
      variables={{ databaseId: props.nodeId, first: 10, offset: 0, publishedConnectionsLineageEnabled }}
    >
      {result => renderQueryResult(result, renderers)}
    </Query>
  );
}

function renderWarnings(urls: SiteUrls): (data: DatabaseLineageUpstreamDataQualityWarningsQuery) => JSX.Element | null {
  return (data: DatabaseLineageUpstreamDataQualityWarningsQuery): JSX.Element | null => {
    const database = data.databases && data.databases[0] ? data.databases[0] : null;
    if (!database) {
      return null;
    }

    const props: WarningStatusProps = {
      subjectArea: database.__typename,
      kind: 'graph',
      anchoredAsset: { __typename: 'DataQualityWarning', asset: { ...database } },
      anchoredWarnings: database.dataQualityWarnings,
      iconOnly: false,
      urls,
      upstreamWarnings: filterOutWarningsFromAnchorUntilCycleIsFixed(database.id, database.upstreamDataQualityWarningsConnection?.nodes ?? emptyWarnings)
    };

    return <WarningStatusChip {...props} />;
  }
}
